'use strict'

import BannerList from '@/pages/Banner/BannerList.vue'
import BannerEdit from '@/pages/Banner/BannerEdit.vue'
import ifAuthenticated from '@/router/middleware'

export default [
  {
    path: '/:site/banners',
    name: 'BannerList',
    component: BannerList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/:site/banners/:id',
    name: 'BannerEdit',
    component: BannerEdit,
    beforeEnter: ifAuthenticated,
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/banner.js